import { StyledPrimaryCell, StyledParagraph, StyledH2 } from '@/components/LimitOrders/utils';

import { SlotMachine } from './SlotMachine';

export function InstantGasFreeSwapsSection() {
  return (
    <StyledPrimaryCell className="rounded-t-[2.125rem] flex-col tablet:flex-row items-center tablet:justify-start relative tablet:bg-[url(/images/matcha-auto/ring-lines.svg)] tablet:bg-no-repeat tablet:bg-bottom-right">
      <SlotMachine />
      <div className="pt-20 tablet:pt-0 pb-14 tablet:pb-0 mx-7 desktop:mx-16 tablet:relative desktop:static w-[343px] tablet:left-[-14px]">
        <StyledH2 className="w-[290px]">Instant gas-free swaps</StyledH2>
        <StyledParagraph>
          Swap crypto without native tokens. Matcha handles the gas for swaps and approvals and
          forget about paying failed transactions.
        </StyledParagraph>
      </div>
    </StyledPrimaryCell>
  );
}
